export default "__VITE_ASSET__601cd474__"